export const ICON_FLOAT_CHATTY = 'chatty';
export const ICON_FLOAT_QUESTION = 'question';
export const ICON_FLOAT_COMMENT = 'comment';
export const ICON_FLOAT_IDEA = 'idea';
export const ICON_FLOAT_MESSAGE = 'message';
export const ICON_FLOAT_PHONE_CALL = 'phone-call';
export const ICON_FLOAT_MESSENGER = 'messenger';
export const ICON_FLOAT_TELEGRAM = 'telegram';
export const ICON_FLOAT_UPLOAD = 'upload_icon';
